import { jsx as t } from "react/jsx-runtime";
import { c as d } from "./index-BNmRGtA6.js";
import { c } from "./clsx-OuTLNxxd.js";
import './Badge.css';const m = "_badge_1f909_1", f = "_primary_1f909_11", z = "_secondary_1f909_17", y = "_error_1f909_23", p = "_isRound_1f909_36", s = {
  badge: m,
  primary: f,
  secondary: z,
  error: y,
  "size-xs": "_size-xs_1f909_29",
  isRound: p,
  "size-s": "_size-s_1f909_41",
  "size-m": "_size-m_1f909_53",
  "size-l": "_size-l_1f909_67"
}, l = d(s.badge, {
  variants: {
    isRound: {
      true: s.isRound
    },
    size: {
      xs: s["size-xs"],
      s: s["size-s"],
      m: s["size-m"],
      l: s["size-l"]
    },
    variant: {
      primary: s.primary,
      secondary: s.secondary,
      error: s.error
    }
  },
  defaultVariants: {
    isRound: !1,
    size: "m",
    variant: "primary"
  }
}), b = ({
  children: r,
  className: a,
  isRound: e,
  size: i,
  style: o,
  variant: _,
  ...n
}) => /* @__PURE__ */ t(
  "span",
  {
    className: c(l({ isRound: e, size: i, variant: _ }), a),
    "data-cxy-name": "badge",
    style: o,
    ...n,
    children: r
  }
);
export {
  b as B
};
